import '../ranking_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.TwitterUserRankingChartView extends Monitoring.Views.Charts.RankingChartView
  twitter_template: JST["backbone/templates/monitoring/charts/twitter_user_ranking"]
  hashtag_template: JST["backbone/templates/monitoring/charts/hashtag_ranking"]
  className: 'chart-ranking twitter-ranking item w2 h3'
  url: "/monitoring/dashboard/charts/users_by_status/"
  tabs:4

  initialize: (@options = {}) ->
    @filename = 'twitter_ranking.png'
    super

  render: ->
    rankings = [
      { id:'user_ranking_chart', title:I18n.t('monitoring.dashboard.charts.user_ranking'), url:"/monitoring/dashboard/charts/user/", field: 'users', spanSize: '3', longNumber: true },
      { id:'named_user_ranking_chart', title:I18n.t('monitoring.dashboard.charts.mention_ranking'), url:"/monitoring/dashboard/charts/mentions/", field: 'mentions', spanSize: '3', longNumber: true },
      { id:'user_followers_ranking_chart', title:I18n.t('monitoring.dashboard.charts.followers_ranking'), url:"/monitoring/dashboard/charts/users_by_followers/", field: 'users', spanSize: '3', longNumber: true },
      { id:'hashtag_ranking_chart', title:I18n.t('monitoring.dashboard.charts.hashtag_ranking'), field: 'hashtags', spanSize: '3', longNumber: true }
    ]
    rank_title = "Rankings de Twitter"
    @$el.html(@generic_template({rankings: rankings,results:@defaultResults, rank_title}))
    @twitterApi(rankings[0], @twitter_template)
    @twitterApi(rankings[1], @twitter_template)
    @twitterApi(rankings[2], @twitter_template)
    @getTwitterHashtags(rankings[3], @hashtag_template)
    @

  getTypeForDrilldownQuery: ->
    'twitter'
